import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

export const rosarioApi = {
  isRosarioUser: ({ signal }: TSignalConfig) => fetcher.query<{ isRosarioUser: boolean }>(`/rosario/me`, { signal }),
}
